export default "https://cdn-static.gokick.com/assets/abc7ffeff8198bd9a29b582a19941a8ba3b1c5b9/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";